module.exports = __webpack_public_path__ + "static/media/cswap-emblem-aqua.c2835c3a.svg";